define.alias("shared/components/shared/badge", "media/components/shared/badge");